import { AxiosResponse } from 'axios';
import { ICountryAbrreviations } from 'src/interfaces/responses';

import { additionalUrls } from './additionalUrls';
import request from './request';

export const getCountries = (): Promise<AxiosResponse<ICountryAbrreviations[]>> =>
  request('get', `${additionalUrls.refData}${additionalUrls.countries}`)();
